module.exports = __webpack_public_path__ + "img/icon-search.20ac9e5b.svg";